package org.catharsis.spendtel.core.platform

import kotlinx.browser.window

actual fun openExternalUrl(url: String) {
    window.open(url, "_blank")
}

actual fun openMailto(
    url: String,
    onResult: ((Boolean) -> Unit)?,
) {
    window.location.href = url
    onResult?.invoke(true)
}
